module.exports = __webpack_public_path__ + "media/interested_companies/images/star08-a7fd8ea7b7068c3813b3c00c3e4d90c1.svg";